<template>
  <BaseReferenceTable
    title="Темы"
    entity-name="Тема"
    :headers="headers"
    :api="api"
    no-data-icon="mdi-sitemap"
    no-data-text="Темы не найдены"
    @load-data="loadData"
    @create-item="createItem"
    @update-item="updateItem"
    @delete-item="deleteItem"
  >
    <!-- Form fields for create/edit dialog -->
    <template #form-fields="{ item }">
      <v-text-field
        v-model="item.name"
        label="Название темы"
        placeholder="Политика, Экономика, Спорт..."
        :rules="nameRules"
        required
        density="compact"
        class="mb-3"
      ></v-text-field>
      
      <v-text-field
        v-model="item.path"
        label="Иерархический путь"
        placeholder="politics, politics.economy, sports.football..."
        :rules="pathRules"
        required
        density="compact"
        class="mb-3"
      ></v-text-field>

      <v-alert
        type="info"
        variant="tonal"
        density="compact"
        class="mb-3"
      >
        Путь определяет место темы в иерархии. Используйте точки для разделения уровней.
        Например: "politics.economy" для темы "Экономика" в разделе "Политика".
      </v-alert>
    </template>

    <!-- Custom table columns -->
    <template v-slot:[`item.name`]="{ item }">
      <div>
        <div class="font-weight-medium">{{ item.name }}</div>
        <div class="text-caption text-grey-darken-1">{{ item.path }}</div>
      </div>
    </template>
  </BaseReferenceTable>
</template>

<script>
// import { ref } from 'vue' // убрано - не используется
import BaseReferenceTable from './BaseReferenceTable.vue'
import { referenceApi } from '@/services/api/referenceApi'

export default {
  name: 'TopicsTable',
  components: {
    BaseReferenceTable
  },
  setup() {
    const api = referenceApi

    const headers = [
      { 
        title: 'Название и путь', 
        key: 'name', 
        sortable: true
      }
    ]

    // Validation rules
    const nameRules = [
      v => !!v || 'Название темы обязательно',
      v => (v && v.length >= 1 && v.length <= 255) || 'Название должно содержать от 1 до 255 символов'
    ]

    const pathRules = [
      v => !!v || 'Иерархический путь обязателен',
      v => /^[a-z0-9_]+(\.[a-z0-9_]+)*$/.test(v) || 'Путь должен содержать только строчные латинские буквы, цифры и символ подчеркивания, разделенные точками',
      v => v.split('.').every(part => part.length > 0) || 'Каждая часть пути должна быть непустой'
    ]

    // Methods
    const loadData = async ({ page, limit, callback }) => {
      try {
        const skip = (page - 1) * limit
        const response = await api.getTopics({ skip, limit })
        callback(response.data)
      } catch (error) {
        console.error('Error loading topics:', error)
        callback(null, 'Ошибка загрузки тем. Проверьте подключение к серверу.')
      }
    }

    const createItem = async ({ item, callback }) => {
      try {
        // Convert path to lowercase
        item.path = item.path.toLowerCase()
        await api.createTopic(item)
        callback(true)
      } catch (error) {
        console.error('Error creating topic:', error)
        const message = error.response?.data?.detail || error.response?.data?.message || 'Не удалось создать тему'
        callback(false, message)
      }
    }

    const updateItem = async ({ item, callback }) => {
      try {
        // Convert path to lowercase
        item.path = item.path.toLowerCase()
        await api.updateTopic(item.id, item)
        callback(true)
      } catch (error) {
        console.error('Error updating topic:', error)
        const message = error.response?.data?.detail || error.response?.data?.message || 'Не удалось обновить тему'
        callback(false, message)
      }
    }

    const deleteItem = async ({ ids, callback }) => {
      try {
        await Promise.all(ids.map(id => api.deleteTopic(id)))
        callback(true)
      } catch (error) {
        console.error('Error deleting topics:', error)
        const message = error.response?.data?.detail || error.response?.data?.message || 'Не удалось удалить темы'
        callback(false, message)
      }
    }


    return {
      api,
      headers,
      nameRules,
      pathRules,
      loadData,
      createItem,
      updateItem,
      deleteItem
    }
  }
}
</script>